<template>
  <section class="image-block">
    <h2 class="title">{{ $props.title }}</h2>
    <h3 class="sub">{{ $props.sub }}</h3>
    <div v-gallery class="js_slider" :class="$props.display === 'grid' ? 'blist' : 'line'">
      <div class="js_frame">
        <ul class="js_slides">
          <li class="js_slide" v-for="(img, index) in $props.imgs">
            <div class="con" @click.stop="goToArticle(index)">
              <img :data-src="img.image" :alt="imgs.description" />
              <h2>{{ img.title }}</h2>
              <a :href="img.link">Read more</a>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="$props.display !== 'grid'" class="prev" @click.stop="goPrev">
        <svg class="ico">
          <use xlink:href="#ico-arr"></use>
        </svg>
      </div>
      <div v-if="$props.display !== 'grid'" class="next" @click.stop="goNext">
        <svg class="ico">
          <use xlink:href="#ico-arr"></use>
        </svg>
      </div>
    </div>
  </section>
</template>

<script>
// Need to import Lory for multiple slider
// import '../../assets/javascripts/lib/lory.min.js';

export default {
    data: function () {
        return {}
    },
    props: {
        imgs: Array,
        display: String,
        title: String,
        sub: String
    },
    methods: {
        goToArticle(ind) {
            window.location.href = this.$props.imgs[ind].link;
        },
        goNext: function(e) {
            e.currentTarget.parentNode.slide.next();
        },
        goPrev: function(e) {
            e.currentTarget.parentNode.slide.prev();
        },
        loadImages: function() {
            let app = this;
            if (app.inViewport(app.$el)) {
                this.loadImageSet();
                window.removeEventListener('scroll', app.loadImages);
            }
        },
        loadImageSet: function() {
            let images = this.$el.querySelectorAll('img');
            for (let i = 0; i < images.length; i++) {
               let el = images[i];
               let src = el.getAttribute("data-src");
               el.src = src;
               el.parentNode.style.backgroundImage = 'url(' + src + ')';
            }
        },
        inViewport: function() {
            let box = this.$el.getBoundingClientRect(),
                win = window,
                doc = document;
            return (
                box.top >= 0 &&
                box.left >= 0 &&
                box.bottom <= (win.innerHeight || doc.documentElement.clientHeight) &&
                box.right <= (win.innerWidth || doc.documentElement.clientWidth)
            );
        }
    },
    directives: {
        'gallery': {
            inserted: function(el, binding, vnode) {
                if (el.classList.contains("line")) {
                    el.slide = window.lory(el, {
                        infinite: 3,
                        slidesToScroll: 3
                    });
                }
            },
            unbind: function(el) {
                el.slide.kill();
            }
        }
    },
    mounted: function() {
        window.addEventListener('scroll', this.loadImages);
    },
    beforeDestroy: function() {
        window.removeEventListener('scroll', this.loadImages);
    }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.blist ul {
  width: 100%;
  list-style: none;
  margin: 1.25rem 0;
}

.sub {
  font-size: .875rem;
  font-weight: 400;
  margin: 0 0 1.25rem 0;
}


.line.js_slider {
  width: 100%;
  position: relative;

  .js_frame {
    position: relative;
    font-size: 0;
    line-height: 0;
    overflow: hidden;
    white-space: nowrap;
  }

  .js_slides {
    display: inline-block;
  }

  .js_slide {
    position: relative;
    display: inline-block;
  }
}

.next,
.prev {
  position: absolute;
  cursor: pointer;
  top: 50%;
  z-index: 1;
  opacity: 0;
  user-select: none;
  margin-top: -1.25rem;

  .ico {
    fill: $col_white;
    width: 2.813rem;
    height: 2.813rem;
    filter: drop-shadow(0 0.125rem 0.125rem $col_quartopacity);
  }

  .line:hover & {
    opacity: 1;
  }
}

.next {
  right: 1.25rem;
}

.prev {
  left: 1.25rem;

  .ico {
    transform: rotate(180deg);
  }
}

li {
  box-sizing: border-box;
  height: 28.125rem;
  position: relative;
  z-index: 1;
  cursor: pointer;
  box-shadow: 0 .125rem .25rem $col_oplightblack;

  &:hover,
  &:focus-within {
    box-shadow: 0 .125rem 1.25rem 0 $col_aqua;
  }

  h2 {
    padding: 0 1.25rem;
  }

  &:hover h2 {
    text-decoration: underline;
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.35);
    width: 100%;
    height: 100%;
  }
}

.line {
  ul {
    height: 28.125rem;
    list-style: none;
  }

  li {
    width: 26.25rem;
    margin-right: 1.25rem;
  }
}

.con {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;

  h2 {
    position: relative;
    font-size: 1.5rem;
  }

  h2, a {
    color: $col_white;
    font-weight: 700;
    text-transform: uppercase;
    text-shadow: 0 .125rem .25rem rgba(0,0,0,0.5);
    z-index: 9;
  }

  a {
    position: absolute;
    cursor: pointer;
    width: 100%;
    bottom: 3.125rem;
    font-size: .875rem;
  }

  h2, a {
    text-align: center;
  }

  img {
    min-width: 100%;
    opacity: 0;
    position: absolute;
  }
}

@supports (display: grid) {
  .blist ul {
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 100%;
    grid-template-columns: repeat(1, 100%);
    row-gap: 1.25rem;
    -webkit-column-gap: 1.25rem;
    -moz-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }
}

@media #{$xl-phone} {
  .blist ul {
    -ms-grid-columns: 50%;
    grid-template-columns: repeat(2, calc(50% - 0.625rem));
  }
}

@media #{$desktop} {
  .con h2 {
    font-size: 2.125rem;
  }

  .title {
    font-size: 1.75rem;
  }
}

</style>